'use client';

import { forwardRef, useMemo } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { VerticalNavContext } from './context/vertical-nav.context';
import { verticalNavRootRecipe } from './styles/vertical-nav-root.styles';
import type { VerticalNavRootPropsInterface } from './types/vertical-nav-root.types';

/**
 * @since 10.0.0
 */
export const VerticalNavRoot = forwardRef<HTMLElement, VerticalNavRootPropsInterface>(
  (props: VerticalNavRootPropsInterface, forwardedRef) => {
    const {
      asChild = false,
      className,
      css: cssProp,
      elevated = true,
      background = true,
      outlined = true,
      tone = 'brand',
      ...rest
    } = props;

    const styles = css(verticalNavRootRecipe.raw({ elevated, background, outlined }), cssProp);

    const Component = asChild ? Slot : 'nav';

    const contextValue = useMemo(() => ({ tone }), [tone]);
    return (
      <VerticalNavContext.Provider value={contextValue}>
        <Component
          ref={forwardedRef}
          data-c11n-component="VerticalNav.Root"
          data-c11n-version={__C11N_VERSION__}
          className={cx('c11n', styles, className)}
          {...rest}
        />
      </VerticalNavContext.Provider>
    );
  },
);

VerticalNavRoot.displayName = 'VerticalNav.Root';
